import { createContext, type ReactNode, useContext } from 'react';

interface PopoutTreeContextType {
  isOpen: boolean;
}

const PopoutTreeContext = createContext<PopoutTreeContextType | undefined>(
  undefined
);

export const usePopoutTree = () => {
  const context = useContext(PopoutTreeContext);
  return context;
};

interface PopoutTreeProviderProps {
  children: ReactNode;
  isOpen: boolean;
  shouldUseContext?: boolean;
}

export const PopoutTreeProvider = ({
  children,
  isOpen,
}: PopoutTreeProviderProps) => {
  return (
    <PopoutTreeContext.Provider
      value={{
        isOpen,
      }}
    >
      {children}
    </PopoutTreeContext.Provider>
  );
};
